import { KeyboardEvent, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NightgraphLogo } from '@components/icons/src/nightgraph-logo';
import { SidebarDesktop } from '@components/sidebar-desktop';
import { EVENT_LIST } from '@constants/routes';
import { LG_VIEWPORT } from '@constants/viewport';
import { CompanyClubContext } from '@contexts/companyClub/companyClub-context';
import { EventContext } from '@contexts/event/event-context';
import { NavigationContext } from '@contexts/navigation/navigation-context';
import { useWindowSize } from '@hooks/use-window-size';
import classNames from 'classnames';

import { Props } from '../sidebar-mobile.types';

export const SidebarMobile = ({
  isMenuOpenInMobile,
  handleIsMenuOpenInMobile,
  closeMenuMobile,
  handleCompanyModal,
}: Props) => {
  const { clubState, companyState } = useContext(CompanyClubContext);
  const { eventState } = useContext(EventContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { preventRedirect, setIsItemClicked } = useContext(NavigationContext);
  const isMobileViewPort = useWindowSize(LG_VIEWPORT as number);
  useEffect(() => {
    if (isMenuOpenInMobile) {
      closeMenuMobile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const onKeyDownHandler = (e: KeyboardEvent<HTMLImageElement>) => {
    if (e.key == 'Escape') {
      handleIsMenuOpenInMobile();
    }
  };

  const navigateToUpcoming = () => {
    if (preventRedirect) {
      setIsItemClicked(true);
    } else {
      navigate(
        EVENT_LIST.replace(':companyId', companyState.legacyId)
          .replace(':clubSlug', clubState.slug)
          .replace(':view', 'upcoming')
      );
    }
  };

  return (
    <>
      <div
        className={classNames(
          {
            hidden: !isMobileViewPort,
            'translate-x-0': isMenuOpenInMobile,
            '-translate-x-full': !isMenuOpenInMobile,
          },
          'flex flex-col z-40 fixed inset-0 backdrop-blur-xs bg-black-1000/30 transition ease-in-out duration-0 transform'
        )}
        onClick={handleIsMenuOpenInMobile}
        onKeyDown={onKeyDownHandler}
        role='button'
        tabIndex={0}
      />
      <div
        className={classNames(
          {
            hidden: !isMobileViewPort,
            'translate-x-0': isMenuOpenInMobile,
            '-translate-x-full': !isMenuOpenInMobile,
          },
          'flex flex-col z-40 fixed inset-0 backdrop-blur-xs transparent-30 transition ease-in-out duration-0 transform'
        )}
        onClick={handleIsMenuOpenInMobile}
        onKeyDown={onKeyDownHandler}
        role='button'
        tabIndex={0}
      />
      <div
        className={classNames(
          {
            'translate-x-0': isMenuOpenInMobile,
            '-translate-x-full': !isMenuOpenInMobile,
          },
          'flex flex-col z-40 max-w-xs fixed inset-0 xs:bg-secondary transition-transform ease-in-out duration-300 shadow-custom'
        )}>
        <div
          className={classNames(
            'flex flex-row items-center justify-between pt-7 pl-9 pr-6 border-gray-200 dark:border-gray-900',
            { 'pb-7': !eventState?.name }
          )}>
          <button onClick={navigateToUpcoming}>
            <NightgraphLogo className='w-[180px] text-primary' />
          </button>
        </div>

        <div className='flex h-full xs:bg-secondary'>
          <SidebarDesktop isCollapsed={false} handleCompanyModal={handleCompanyModal} />
        </div>
      </div>
    </>
  );
};
